import React from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import { Button } from 'antd';

const SubmitAddMassOffering = ({
  isOnlinePayment,
  isPaymentExpiring,
  watch,
  loading,
  name,
  disabled,
}) => {
  const offeringAmount = watch(name);

  const isOfferingAmountGreaterThanZero = offeringAmount !== null && offeringAmount > 0;

  let buttonText;
  if (isOnlinePayment) {
    if (isOfferingAmountGreaterThanZero) {
      buttonText = 'Zamawiam intencję i przekazuję ofiarę przez Tpay';
    } else {
      buttonText = 'Zamawiam intencję';
    }
  } else {
    // payment_type: to_be_chosen
    buttonText = 'Rezerwuję intencję';
  }

  const content = (
    <>
      Zgłoszona przez Ciebie intencja zostanie <b>zarezerwowana na 24 godziny</b>. Przekaż ofiarę za
      pomocą bramki płatniczej Tpay (przycisk poniżej). Jeśli jej nie złożysz, po 24 godzinach
      intencja zostanie anulowana. Informacje o statusie intencji otrzymasz na podany adres e-mail.
    </>
  );

  const showContent = isOnlinePayment && isOfferingAmountGreaterThanZero && isPaymentExpiring;

  return (
    <>
      <div className="md-form input-group ">
        <AnimateHeight duration={500} height={showContent ? 'auto' : 0}>
          <p className="grey-text">
            <small>
              <em>{content}</em>
            </small>
          </p>
        </AnimateHeight>

        <Button
          block
          className="w-auto ml-auto mr-auto"
          disabled={disabled}
          htmlType="submit"
          loading={loading}
          size="large"
          type="primary"
        >
          <span>{buttonText}</span>
        </Button>
      </div>
    </>
  );
};

SubmitAddMassOffering.propTypes = {
  watch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isOnlinePayment: PropTypes.bool.isRequired,
  isPaymentExpiring: PropTypes.bool.isRequired,
};

export default SubmitAddMassOffering;
